import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`

  const transformOrigin = '6.2675 11.34'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M11.8508 17.3401C11.2508 16.3601 10.3307 15.29 9.28075 13.48C7.16075 9.80004 8.63075 0.290039 8.63075 0.290039H6.33075H3.90076C3.90076 0.290039 5.38075 9.81004 3.25075 13.48C2.20075 15.3 1.27076 16.3701 0.680758 17.3401C0.070758 18.3401 -0.189241 19.2301 0.150759 19.9301C0.480759 20.6201 1.14076 20.7701 1.79076 20.8401C2.21076 20.8801 2.57074 20.82 3.01074 21.07C4.13074 21.71 4.89075 22.39 6.27075 22.39C7.65075 22.39 8.41075 21.71 9.53075 21.07C9.98075 20.81 10.3407 20.8801 10.7507 20.8401C11.4007 20.7701 12.0607 20.6201 12.3907 19.9301C12.7207 19.2201 12.4608 18.3301 11.8508 17.3401Z"
          fill={`url(#${randomGradientId1})`}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="6.26905"
            y1="2.25744"
            x2="6.26905"
            y2="22.2229"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8488" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
